export const supportExpensesTypes = {
  HANDLE_SUPPORT_EXPENSES_INPUTS: 'HANDLE_SUPPORT_EXPENSES_INPUTS',
  GET_SUPPORT_EXPENSES: 'GET_SUPPORT_EXPENSES',
  EDIT_PERIOD_EXPENSES: 'EDIT_PERIOD_EXPENSES',
};